import { createReducer, on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';

import { SenderDomain } from '../models';
import { SenderDomainActions } from '../actions';

export interface State extends EntityState<SenderDomain> {}

export const adapter: EntityAdapter<SenderDomain> = createEntityAdapter<
  SenderDomain
>({
  selectId: (a) => a.id,
  sortComparer: (a, b) => a.accountId.localeCompare(b.accountId),
});

export const initialState: State = adapter.getInitialState();

export const reducer = createReducer(
  initialState,

  on(SenderDomainActions.createSuccess, (state, { senderDomain }) =>
    adapter.addOne(senderDomain, state),
  ),

  on(SenderDomainActions.deleteSuccess, (state, { domainId }) =>
    adapter.removeOne(domainId, state),
  ),

  on(SenderDomainActions.fetchSuccess, (state, { senderDomains }) =>
    adapter.upsertMany(senderDomains, state),
  ),
);
